export default "__VITE_ASSET__ba2dfaf1__"